import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { Account, Accounts } from '@models/account';
import { OverlayService } from '@services/overlay';
import { CloseOverlayKeyboardDirective, CloseOverlayClickDirective } from '../../directives/close-overlay.directives';
import { FormsModule } from '@angular/forms';
import { I18nValueDirective } from '../../directives/i18n.directives';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { WebhooksComponent } from '../webhooks/webhooks.component';

@Component({
  selector: 'lv-account-form',
  templateUrl: './account-form.component.html',
  styleUrls: ['./account-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    CloseOverlayKeyboardDirective,
    FormsModule,
    I18nValueDirective,
    CloseOverlayClickDirective,
    TranslateModule,
    WebhooksComponent
  ]
})
export class AccountFormComponent {
  private accountService = inject(Accounts);
  private overlayService = inject(OverlayService);

  @Input() account: Account;

  get title(): string {
    return `account-form.component.title.${this.account.newRecord()}`;
  }

  save() {
    this.accountService.$save(this.account).then(
      () => this.overlayService.closeTopOverlay(),
      (account: Account) => console.error(account.$error)
    );
  }
}
